export default class AppFilter extends HTMLElement {
    connectedCallback() {
        this.button = this.querySelector('[data-filter-toggle]');
        this.menu = this.querySelector('[data-filter-menu]');

        if (!this.button || !this.menu) return;

        this.button.setAttribute('aria-expanded', 'false');
        this.menu.hidden = true;

        this.onToggle = this.onToggle.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.button.addEventListener('click', this.onToggle);
        document.addEventListener('click', this.onDocumentClick);
        this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
        if (!this.button) return;

        this.button.removeEventListener('click', this.onToggle);
        document.removeEventListener('click', this.onDocumentClick);
        this.removeEventListener('keydown', this.onKeydown);
    }

    onToggle() {
        this.isOpen() ? this.close() : this.open();
    }

    onDocumentClick(event) {
        if (this.contains(event.target)) return;

        this.close();
    }

    onKeydown(event) {
        if (event.key !== 'Escape') return;

        this.close();
        this.button.focus();
    }

    isOpen() {
        return this.classList.contains('is-open');
    }

    open() {
        this.classList.add('is-open');
        this.button.setAttribute('aria-expanded', 'true');
        this.menu.hidden = false;
    }

    close() {
        this.classList.remove('is-open');
        this.button.setAttribute('aria-expanded', 'false');
        this.menu.hidden = true;
    }
}

customElements.define('app-filter', AppFilter);